export default "__VITE_ASSET__DIkoUJvh__"